import { IonButton, useIonAlert } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { assignUsers } from "../../../store/formsubmitted/actions/assignUsers";
import { selectUsersSelectedCounter } from "../../../store/formsubmitted/selectors/selectUsersSelectedCounter";

export const ConfirmButton = () => {
  const dispatch = useDispatch();
  const [present] = useIonAlert();
  const selectedUsersCounter = useSelector(selectUsersSelectedCounter);

  const onSubmit = async () => {
    dispatch(assignUsers());
  };

  return (
    <>
      <IonButton
        fill="solid"
        size="large"
        color="secondary"
        onClick={() => {
          present({
            header: `¿Deseas asignar ${selectedUsersCounter} ${
              selectedUsersCounter === 1 ? "usuario" : "usuarios"
            }?`,
            buttons: [
              "No",
              {
                text: `Asignar ${selectedUsersCounter} ${
                    selectedUsersCounter === 1 ? "usuario" : "usuarios"
                }`,
                handler: () => onSubmit(),
              },
            ],
          });
        }}
      >
        Guardar
      </IonButton>
    </>
  );
};
